import Splide from '@splidejs/splide';

$(function () {
  const splide = new Splide(".topMv-splide", {
    autoplay: true, // 自動再生
    type: "fade", // フェード
    rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
    pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
    pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
    arrows: false,
    pagination: false,
    interval: 7000, // 自動再生の間隔
    speed: 2000, // スライダーの移動時間
  }).mount();
});

$(function () {
  const options = {
    fixedWidth: "28%",
    type: "loop",
    arrows: false,
    drag: "free",
    flickPower: 100,
    pagination: false,
    autoScroll: {
      speed: 0.4,
      pauseOnHover: false,
      pauseOnFocus: true,
    },
    breakpoints: {
      768: {
        fixedWidth: "200px",
      }
    }
  };
  const splide = new Splide(".rec-splide", options);
  splide.mount(window.splide.Extensions);
});

$(function () {
  const options = {
    fixedWidth: "28%",
    type: "loop",
    arrows: false,
    drag: "free",
    flickPower: 100,
    pagination: false,
    autoScroll: {
      speed: 0.4,
      pauseOnHover: false,
      pauseOnFocus: true,
    },
    breakpoints: {
      768: {
        fixedWidth: "200px",
      }
    }
  };
  const splide = new Splide(".rec-splide02", options);
  splide.mount(window.splide.Extensions);
});
